






























































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import CharacterIcon from '@/components/parts/CharacterIcon.vue';
import KmyChatTagText from '@/components/parts/KmyChatTagText.vue';
import KmyLogTagText from '@/components/parts/KmyLogTagText.vue';
import MapLogList from '@/components/parts/MapLogList.vue';
import * as api from '@/api/api';
import * as def from '@/common/definitions';
import ArrayUtil from '@/models/common/arrayutil';
import Enumerable from 'linq';
import NotificationService from '../../services/notificationservice';

@Component({
  components: {
    CharacterIcon,
    KmyChatTagText,
    KmyLogTagText,
    MapLogList,
  },
})
export default class SimpleCharacterList extends Vue {
  @Prop() public characters!: api.Character[];
  @Prop() public countries!: api.Country[];
  @Prop({
    default: () => undefined,
  }) public towns?: api.Town[];
  @Prop({
    default: -1,
  }) public myCharacterId!: number;
  @Prop({
    default: -1,
  }) public myCountryId!: number;
  @Prop({
    default: false,
  }) public isShowCustomSoldierTypeDetail!: boolean;
  @Prop({
    default: false,
  }) public isShowFormationType!: boolean;
  @Prop({
    default: false,
  }) public canEdit!: boolean;
  @Prop({
    default: false,
  }) public canPunishment!: boolean;
  @Prop({
    default: false,
  }) public canPrivateChat!: boolean;
  @Prop({
    default: false,
  }) public canReinforcement!: boolean;
  @Prop({
    default: true,
  }) public isWithFrom!: boolean;
  @Prop({
    default: false,
  }) public canSelect!: boolean;
  @Prop({
    default: () => new api.Character(-1),
  }) public value!: api.Character;
  @Prop({
    default: () => undefined,
  }) public commands?: api.CharacterCommand[];
  @Prop({
    default: () => undefined,
  }) public otherCharacterCommands?: api.CharacterCommand[];
  @Prop({
    default: false,
  }) public isSortByTime!: boolean;
  @Prop({
    default: false,
  }) public isShowMoney!: boolean;
  @Prop({
    default: true,
  }) public isShowSoldier!: boolean;
  @Prop({
    default: false,
  }) public isShowTown!: boolean;

  private isOpenPostsPopup: boolean = false;
  private openMoreCommands: number = 0;
  private ignoreIds: number[] = [];

  private get orderedCharacters(): api.Character[] {
    if (this.isSortByTime) {
      return Enumerable.from(this.characters)
        .where((c) => !this.ignoreIds.some((id) => c.id === id))
        .orderBy((c) => api.DateTime.toDate(c.lastUpdated).getTime())
        .toArray();
    }
    return this.characters;
  }

  private getCountryColorId(countryId: number): number {
    const country = ArrayUtil.find(this.countries, countryId);
    if (country) {
      return country.colorId;
    } else {
      return 0;
    }
  }

  private getPostName(charaId: number, countryId: number, isContainsRole: boolean | undefined): string {
    const country = ArrayUtil.find(this.countries, countryId);
    if (country && country.posts) {
      const posts = country.posts.filter((p) => p.characterId === charaId).map((p) => p.type);
      if (posts.length <= 0) {
        posts.push(0);
      }
      const postTypes = def.COUNTRY_POSTS
        .filter((pt) => posts.some((p) => p === pt.id) && (isContainsRole || !pt.isRoleGroup))
        .map((pt) => pt.name);
      return postTypes.join(' / ');
    }
    return '';
  }

  private hasSoldierData(chara: api.Character): boolean {
    return chara.soldierType !== undefined && chara.soldierType !== null;
  }

  private getSoldierTypeName(chara: api.Character): string {
    const soldierType = Enumerable.from(def.SOLDIER_TYPES).firstOrDefault((st) => st.id === chara.soldierType);
    if (soldierType) {
      return soldierType.name;
    }
    return def.SOLDIER_TYPES[0].name;
  }

  private getTownName(townId: number): string {
    if (this.towns) {
      const town = this.towns.find((t) => t.id === townId);
      if (town) {
        return town.name;
      }
    }
    return '';
  }

  private getCharacterNextTime(time: api.DateTime): api.DateTime {
    const dt = api.DateTime.toDate(time);
    dt.setSeconds(dt.getSeconds() + def.UPDATE_TIME);
    return api.DateTime.fromDate(dt);
  }

  private getCommandUniqueKey(cmd: api.CharacterCommand): number {
    if (cmd) {
      return api.GameDateTime.toNumber(cmd.gameDate);
    } else {
      return Math.random() * 1000;
    }
  }

  private getCharacterFormationName(chara: api.Character): string {
    const formationType = Enumerable.from(def.FORMATION_TYPES).firstOrDefault((st) => st.id === chara.formationType);
    if (formationType) {
      return formationType.name;
    }
    return '通常';
  }

  private getCharacterFormationType(chara: api.Character): string {
    const formationType = Enumerable.from(def.FORMATION_TYPES).firstOrDefault((st) => st.id === chara.formationType);
    if (formationType) {
      return formationType.type;
    }
    return '無';
  }

  private getCharacterCommands(chara: api.Character): Array<(api.CharacterCommand | undefined)> {
    if (chara.countryId !== this.myCountryId) {
      return [];
    }
    if (this.commands && this.otherCharacterCommands) {
      const startNumber = chara.lastUpdatedGameDate.year >= def.UPDATE_START_YEAR ?
        api.GameDateTime.toNumber(chara.lastUpdatedGameDate) + 1 :
        api.GameDateTime.toNumber(new api.GameDateTime(def.UPDATE_START_YEAR, 1));
      const endNumber = startNumber + 4;
      const cmds = Enumerable.from(this.otherCharacterCommands)
        .concat(this.commands)
        .where((c) => c.characterId === chara.id)
        .where((c) => startNumber <= api.GameDateTime.toNumber(c.gameDate) &&
          api.GameDateTime.toNumber(c.gameDate) < endNumber);
      return [
        cmds.firstOrDefault((c) => api.GameDateTime.toNumber(c.gameDate) === startNumber),
        cmds.firstOrDefault((c) => api.GameDateTime.toNumber(c.gameDate) === startNumber + 1),
        cmds.firstOrDefault((c) => api.GameDateTime.toNumber(c.gameDate) === startNumber + 2),
        cmds.firstOrDefault((c) => api.GameDateTime.toNumber(c.gameDate) === startNumber + 3),
      ];
    } else if (chara.commands) {
      return chara.commands;
    }
    return [];
  }

  private stopCommand(chara: api.Character) {
    this.$emit('yesno', {
      message: '本当に謹慎しますか？',
      onYes: () => {
        if (!chara.isStopCommand && (chara as any).detail) {
          Vue.set(chara, 'isLoadingDetail', true);
          api.Api.setCharacterStopCommand(chara.id)
            .then(() => {
              (chara as any).detail.isStopCommand = true;
              NotificationService.stopedCommand.notifyWithParameter(chara.name);
              this.openMoreCommands = 0;
            })
            .catch((ex) => {
              if (ex.data && ex.data.code === api.ErrorCode.blockedActionError) {
                NotificationService.actionBlocked.notify();
              } else {
                NotificationService.stopCommandFailed.notifyWithParameter(chara.name);
              }
            })
            .finally(() => {
              Vue.set(chara, 'isLoadingDetail', false);
            });
        }
      },
    });
  }

  private dismissal(chara: api.Character) {
    this.$emit('yesno', {
      message: '本当に解雇しますか？',
      onYes: () => {
        if ((chara as any).detail) {
          Vue.set(chara, 'isLoadingDetail', true);
          api.Api.setCharacterDismissal(chara.id)
            .then(() => {
              this.ignoreIds.push(chara.id);
              NotificationService.dismissaled.notifyWithParameter(chara.name);
              this.openMoreCommands = 0;
            })
            .catch((ex) => {
              if (ex.data && ex.data.code === api.ErrorCode.blockedActionError) {
                NotificationService.actionBlocked.notify();
              } else {
                NotificationService.dismissalFailed.notifyWithParameter(chara.name);
              }
            })
            .finally(() => {
              Vue.set(chara, 'isLoadingDetail', false);
            });
        }
      },
    });
  }

  private togglePostsPopup(chara: api.Character) {
    Vue.set(chara, 'isOpenPostsPopup', !(chara as any).isOpenPostsPopup);
  }

  private togglePostsPopup2(chara: api.Character) {
    Vue.set(chara, 'isOpenPostsPopup2', !(chara as any).isOpenPostsPopup2);
  }

  private toggleOpenMoreCommands() {
    this.openMoreCommands = ((this.openMoreCommands + 1) % 3);
  }

  private toggleDetail(chara: api.Character) {
    Vue.set(chara, 'isOpenDetail', !(chara as any).isOpenDetail);
    if ((chara as any).isOpenDetail) {
      Vue.set(chara, 'isLoadingDetail', true);
      const id = (chara as any).characterId ? (chara as any).characterId : chara.id;
      api.Api.getCharacterDetail(id)
        .then((detail) => {
          if (detail.skills) {
            const skillInfos = detail.skills.map((s) => {
              const st = def.CHARACTER_SKILL_TYPES.filter((stt) => stt.id === s.type);
              if (st.length > 0) {
                return st[0];
              }
              return undefined;
            }).filter((s) => s !== undefined);
            Vue.set(chara, 'skillInfos', skillInfos);
          }
          if (detail.formation) {
            const type = detail.formation.type;
            const info = def.FORMATION_TYPES.filter((ft) => ft.id === type);
            if (info.length > 0) {
              Vue.set(chara, 'formationInfo', info[0]);
            }
          }
          Vue.set(chara, 'detail', detail);
        })
        .catch(() => {
          NotificationService.getCharacterDetailFailed.notify();
        })
        .finally(() => {
          Vue.set(chara, 'isLoadingDetail', false);
        });
    }
  }
}
